"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _globalComponentsLibrary = require("global-components-library");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _constants = require("../../../utils/constants");
var _helpers = require("../../../utils/helpers");
var _hooks = require("../../../utils/hooks");
require("./FileSlider.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FileSlider = function FileSlider(_ref) {
  var media = _ref.media,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    onUploadAttachments = _ref.onUploadAttachments,
    onDeleteAttachment = _ref.onDeleteAttachment,
    mediaType = _ref.mediaType,
    maxImgToSend = _ref.maxImgToSend;
  var _useTranslation = (0, _reactI18next.useTranslation)(['chat']),
    t = _useTranslation.t;
  var sliderRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDown = _useState2[0],
    setIsDown = _useState2[1];
  var _useError = (0, _hooks.useError)(),
    _useError2 = _slicedToArray(_useError, 3),
    error = _useError2[0],
    showError = _useError2[1],
    toggleError = _useError2[2];
  var _useState3 = (0, _react.useState)({
      startX: 0,
      scrollLeft: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  var onClickMiniature = function onClickMiniature(id) {
    onSelect(id);
  };
  var mouseDown = function mouseDown(e) {
    setIsDown(true);
    setPosition({
      startX: sliderRef.current.offsetLeft,
      scrollLeft: sliderRef.current.offsetTop
    });
  };
  var mouseUp = function mouseUp(e) {
    setIsDown(false);
    sliderRef.current.classList.remove('sliding');
  };
  var mouseMove = function mouseMove(e) {
    if (!isDown) return;
    e.preventDefault();
    sliderRef.current.classList.add('sliding');
    var eventPosition = e.pageX - sliderRef.current.offsetLef;
    var slide = eventPosition - position.startX;
    sliderRef.current.offsetLef = position.scrollLeft - slide;
  };
  var slide = function slide(direction) {
    var slideAmount = calculateSlideAmount(direction);
    var start = sliderRef.current.scrollLeft;
    smoothHorizontalScroll(500, slideAmount, start);
  };
  var calculateSlideAmount = function calculateSlideAmount(direction) {
    var _slider = sliderRef.current;
    var currentView = direction === 'left' ? _slider.scrollLeft + _slider.offsetWidth : _slider.scrollLeft;
    var childNodes = Array.from(_slider.children);
    var nodeWidthSum = 0;
    for (var _i = 0, _childNodes = childNodes; _i < _childNodes.length; _i++) {
      var node = _childNodes[_i];
      var nodeWidth = (0, _helpers.getOuterWidth)(node);
      nodeWidthSum += nodeWidth;
      if (nodeWidthSum >= currentView) {
        var showingPart = direction === 'left' ? nodeWidthSum - currentView : nodeWidth;
        return (_slider.offsetWidth - showingPart) * direction;
      }
    }
    return _slider.offsetWidth;
  };
  var smoothHorizontalScroll = function smoothHorizontalScroll(time, amount, start) {
    var curTime = 0;
    for (var scrollCounter = 0; curTime <= time; scrollCounter++) {
      window.setTimeout(smoothHorizontalScrollBehavior, curTime, scrollCounter * amount / 100 + start);
      curTime += time / 100;
    }
  };
  var smoothHorizontalScrollBehavior = function smoothHorizontalScrollBehavior(amount) {
    sliderRef.current.scrollLeft = amount;
  };
  var getFiles = (0, _hooks.useFileHandler)(mediaType, maxImgToSend, showError);
  var addAttachments = function addAttachments(e) {
    try {
      onUploadAttachments(getFiles(e.target.files));
    } catch (err) {
      console.log(err);
    }
  };
  (0, _react.useEffect)(function () {
    if (media.length > 0 && selected == null) {
      onSelect(media.length - 1);
    }
  }, [media, selected]);
  var onClickAttach = function onClickAttach() {
    inputRef.current.click();
  };
  var onClose = function onClose(e, i) {
    e.stopPropagation();
    onDeleteAttachment(media[i]);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-miniaturs-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-miniaturs-wrapper",
    ref: sliderRef,
    onMouseDown: function onMouseDown(e) {
      return mouseDown(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      return mouseUp(e);
    },
    onMouseUp: function onMouseUp(e) {
      return mouseUp(e);
    },
    onMouseMove: function onMouseMove(e) {
      return mouseMove(e);
    }
  }, media.map(function (val, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: 'uin-miniaturs' + (selected === i ? ' active' : ''),
      onClick: function onClick() {
        return onClickMiniature(i);
      }
    }, val.type === 'image' ? /*#__PURE__*/_react["default"].createElement("img", {
      src: val.url,
      alt: "preview"
    }) : val.type === 'video' ? /*#__PURE__*/_react["default"].createElement("video", {
      src: val.url,
      preload: "metadata"
    }) : val.type === 'audio' ? /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon large headset"
    }) : /*#__PURE__*/_react["default"].createElement("i", {
      className: 'gcl-icon large ' + _constants.FILE_ICONS[(0, _helpers.fileExtension)(val.name || val.url).toLowerCase()]
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-miniatur-header"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon close",
      onClick: function onClick(e) {
        return onClose(e, i);
      }
    })));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-miniaturs attach",
    onClick: onClickAttach
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    multiple: true,
    className: "input",
    ref: inputRef,
    onChange: addAttachments
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon plus"
  }))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, _extends({}, error, {
    toggle: toggleError,
    accept: t('errorFormat.attachErrorCommit')
  })));
};
var _default = exports["default"] = FileSlider;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MediaViewer/Slider/FileSlider.js
// module id = 1417
// module chunks = 0